import React from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Alert,Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons';

const SuccessCollecteReceiptAll = (props) =>{
    const t = useTranslate();
    
    return(<>
        <Alert variant="success">
            <Alert.Heading className='text-center'>{props.message}</Alert.Heading>
            <div className='d-flex justify-content-center mt-4' style={{fontSize:'3em'}}>
                <FontAwesomeIcon icon={faCheckCircle} />
            </div>
            
            <hr />
            <div className="d-flex justify-content-end">
                <Link variant="btn btn-outline-primary" to={"/wms/"+props.wmsid+"/"+props.path}>
                    {t('btnBack')}
                </Link>
            </div>
        </Alert>
    </>
    )

}

export default SuccessCollecteReceiptAll;